import { createContext } from 'react';

export const interactionContext = createContext<any>(null);
